import { render, staticRenderFns } from "./ClientsSection.vue?vue&type=template&id=126343e0"
import script from "./ClientsSection.vue?vue&type=script&lang=js"
export * from "./ClientsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports